/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsChampionMasteryDtoSchema } from "./championMasteryDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsTournamentParticipantDtoSchema = z.object({
  id: z.string().nullish(),
  userId: z.string().nullish(),
  userDisplayName: z.string().nullish(),
  userAvatarUrl: z.string().nullish(),
  riotAccountGameName: z.string().nullish(),
  riotAccountTagLine: z.string().nullish(),
  riotAccountRegion: z.string().nullish(),
  mainRole: z.string().nullish(),
  secondaryRole: z.string().nullish(),
  desiredRole: z.string().nullish(),
  currentRank: z.string().nullish(),
  evaluatedRank: z.string().nullish(),
  evaluatedRankRegion: z.string().nullish(),
  points: z.optional(z.int()),
  moderatorAdjustedPoints: z.int().nullish(),
  playerNote: z.string().nullish(),
  status: z.string().nullish(),
  registeredAt: z.optional(z.iso.datetime()),
  get topChampionMasteries() {
    return z.array(goodLuckCoreDTOsChampionMasteryDtoSchema).nullish();
  },
  isAppointedCaptain: z.optional(z.boolean()),
});
